// extracted by mini-css-extract-plugin
module.exports = {"keyhighlights":"mXzOP","item":"Ka_1a","list_items":"rB5E9","link":"IHpti"};